<template>
  <button :type="type" :disabled="disabled || loading"
    class="inline-flex items-center justify-center gap-2 cursor-pointer rounded-[var(--radius-md)] font-semibold transition-all duration-150 active:scale-[0.98] disabled:opacity-50 disabled:pointer-events-none"
    :class="[sizes[size], variants[variant], { 'w-full': full }]" @click="$emit('click')">
    <Commerce-Spinner v-if="loading" :size="16" />
    <span v-if="!loading && icon" v-html="icon" />
    <slot />
  </button>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: 'primary' | 'secondary' | 'ghost' | 'outline' | 'danger' | 'text'
    size?: 'sm' | 'md' | 'lg'
    full?: boolean
    loading?: boolean
    disabled?: boolean
    icon?: string
    type?: 'button' | 'submit'
  }>(),
  {
    variant: 'primary',
    size: 'md',
    full: false,
    loading: false,
    disabled: false,
    type: 'button',
  }
)

defineEmits<{ click: [] }>()

const sizes: Record<string, string> = {
  sm: 'h-9 px-3.5 text-sm',
  md: 'h-11 px-5 text-[15px]',
  lg: 'h-13 px-7 text-base',
}
const variants: Record<string, string> = {
  primary: 'bg-primary text-primary-foreground hover:bg-[var(--primary-strong)] shadow-[var(--shadow-sm)]',
  secondary: 'bg-secondary text-secondary-foreground hover:brightness-97',
  ghost: 'bg-transparent text-foreground hover:bg-secondary',
  outline:
    'bg-transparent text-foreground border border-border  shadow-[0px_1px_2px_0px_#0000001F,_0px_2px_3px_0px_#FFFFFFBF_inset] hover:bg-transparent hover:shadow-[0px_2px_3px_0px_#0000001F,_0px_2px_3px_0px_#FFFFFFBF_inset]',
  danger: 'bg-[var(--danger)] text-white hover:brightness-95',
  text: 'bg-transparent  hover:bg-transparent hover:brightness-100',
}
</script>
